export type Theme = {
  mode: 'light' | 'dark';
  paper: {
    default: string;
    hover: string;
    modal: string;
    disabled: string;
  };
  text: {
    default: string;
    disabled: string;
    error: string;
    link: string;
    linkVisited: string;
  };
  border: {
    default: string;
    focus: string;
  };
  structure: {
    default: string;
  };
};

const darkTheme = (mode: 'light' | 'dark') =>
  ({
    mode,
    paper: {
      default: '#121212',
      hover: '#1b1b1b',
      modal: '#2a2a2a',
      disabled: '#3b3b3b',
    },
    text: {
      default: '#e0e0e0',
      disabled: '#707070',
      error: '#eb5600ff',
      link: '#88b2ffff',
      linkVisited: '#dbb2ffff',
    },
    border: {
      default: '#3d3d3d',
      focus: '#ffca67',
    },
    structure: {
      default: '#c2c2c2',
    },
  }) as const satisfies Theme;

const lightTheme = (mode: 'light' | 'dark') =>
  ({
    mode,
    paper: {
      default: '#163472',
      hover: '#25488f',
      modal: '#112a5c',
      disabled: '#D4CDC0',
    },
    text: {
      default: '#FBFFFA',
      disabled: '#b3b3b3',
      error: '#E74F16',
      link: '#adc7e2',
      linkVisited: '#c2aee4',
    },
    border: {
      default: '#D0C8BA',
      focus: '#E74F16',
    },
    structure: {
      default: '#1A1A1A',
    },
  }) as const satisfies Theme;

export { darkTheme, lightTheme };
